<template>
  <div class="organ-container" style="display: flex">
    <div class="side">
      <Learning
        :dataList="dataList"
        title="机构类型"
        @learnClick="handleLearn"
        @requestAll="handleAll"
      ></Learning>
    </div>
    <div class="content" v-if="mechanismList.length > 0 || scrollFlag">
        <Mechanism
          v-for="item in mechanismList"
          :key="item.id"
          :mechanism="item"
        ></Mechanism>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
    </div>
    <NoData v-if="mechanismList.length == 0 && !scrollFlag"></NoData>
  </div>
</template>

<script>
import Learning from "@/components/pager/Learning.vue";
import Mechanism from "../components/Mechanism.vue";
import Scroll from "@/components/paging/scroll";
import NoData from "@/views/PCView/search/components/NoData.vue";
export default {
  components: {
    Learning,
    Mechanism,
    Scroll,
    NoData,
  },
  data() {
    return {
      dataList: [],
      mechanismList: [],
      // 分页
      pageNum: 1,
      total: 0,
      params: {
        name: this.$route.query.paramStr || null,
        pageNo: 1,
        pageSize: 5,
      },
      // 加载状态
      scrollFlag: false,
      isEnd: false,
      filterFlag: false,
    };
  },
  created() {
    this.orgList(this.params);
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem("Table"))) {
      this.dataList = JSON.parse(
        sessionStorage.getItem("Table")
      ).OrgBaseTypeEnum;
    }
    this.$bus.$on("mainScroll", this.handlePager);
  },
  beforeDestroy() {
    this.$bus.$off("mainScroll", this.handlePager);
  },
  methods: {
    handlePager() {
      let containerHeight =
        document.documentElement.clientHeight +
        document.documentElement.scrollTop;
      let scrollHeight = document.documentElement.scrollHeight;
      if (containerHeight + 1 >= scrollHeight && !this.scrollFlag && !this.isEnd ) {
        if (this.filterFlag) {
          this.orgList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        } else {
          this.orgList({
            ...this.params,
            pageNo: ++this.pageNum,
          });
        }
      }
    },
    async orgList(data) {
      this.isEnd = false
      this.scrollFlag = true
      const resp = await this.$apis.searchServe.orgList(data);
      this.total = +resp.data.total;
      this.scrollFlag = false
      this.mechanismList.push(...resp.data.list);
      this.isEnd = this.pageNum >= this.total / 5
    },
    handleLearn(i, item) {
      this.filterFlag = true;
      if (this.filterFlag) {
        this.pageNum = 1;
        this.mechanismList = [];
      }
      this.params.type = item.id;
      this.orgList(this.params);
    },
    handleAll() {
      this.curPage = 2;
      this.mechanismList = [];
      this.filterFlag = false;
      delete this.params.type;
      this.orgList(this.params);
    },
  },
};
</script>

<style lang="scss" scoped>
.side {
  width: 300px;
  margin-right: 11px;
}
.content {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  width: 890px;
}
</style>
